import { __awaiter } from 'tslib';
import React__default from 'react';
import { SpriteContextProvider } from 'react-lazy-svg';

const loadSVG = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const basePath = '/visuels/0_TECH/shared-svg/';
    const response = yield fetch(basePath + url);
    return response.text();
});
const SvgProvider = ({ children }) => {
    return (React__default.createElement(SpriteContextProvider, { loadSVG: loadSVG, embeddedSSR: true }, children));
};

export { SvgProvider };
